/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		"theme": 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./public/assets/";
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push(["./src/scripts/layout/theme.js","vendors"]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/scripts/components/animations.js": 
/*!**********************************************!*\
  !*** ./src/scripts/components/animations.js ***!
  \**********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
  /* harmony import */ var gsap_ScrollTrigger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gsap/ScrollTrigger.js */ "./node_modules/gsap/ScrollTrigger.js");
   // Also works with TweenLite and TimelineLite
  
  
  gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].registerPlugin(gsap_ScrollTrigger_js__WEBPACK_IMPORTED_MODULE_1__["ScrollTrigger"]);
  
  const animation = {
    staggeredFadeInUp: function (staggerElem, triggerElement) {
      let tlStaggerUp = gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
        scrollTrigger: {
          trigger: triggerElement,
          start: "top 60%",
        },
      });
      tlStaggerUp.staggerFromTo(
        staggerElem,
        1,
        {
          autoAlpha: 0,
          y: 40,
        },
        { autoAlpha: 1, y: 0, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeOut },
        0.2
      );
    },
    slideInUp: function (elm) {
      let tlStaggerUp = gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
        scrollTrigger: {
          trigger: elm,
          start: "top 80%",
        },
      });
      tlStaggerUp.fromTo(
        elm,
        1,
        {
          yPercent: 100,
        },
        { yPercent: 0, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeOut }
      );
    },
    fadeInUp: function (elm) {
      let tlStaggerUp = gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
        scrollTrigger: {
          trigger: elm,
          start: "top 90%",
        },
      });
      tlStaggerUp.fromTo(
        elm,
        1,
        {
          autoAlpha: 0,
          y: 30,
        },
        {
          autoAlpha: 1,
          y: 0, 
          ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeOut 
        }
      );
    },
  };
  
  if (window.theme.showElementStaggering) {
    let animeContainer = document.querySelectorAll("[data-stagger-wrap]");
  
    animeContainer.forEach(function (item, index) {
      let staggerElem = item.querySelectorAll("[data-animate]");
      animation.staggeredFadeInUp(staggerElem, item);
    });
  
    let slideInUp = document.querySelectorAll("[data-animate-slideinup]");
  
    slideInUp.forEach(function (item, index) {
      item.style.overflow = "hidden";
      item.innerHTML =
        '<span class="block" data-animate-elm>' + item.textContent + "</span>";
      animation.slideInUp(item.querySelector("[data-animate-elm]"));
    });
    
    let fadeInUp = document.querySelectorAll("[data-animate-fadeinup]");
  
    fadeInUp.forEach(function (item, index) {
      animation.fadeInUp(item);
    });

    if(document.body.contains(document.querySelector('.parallax_scroll'))) {
      let floaterContainers = document.querySelectorAll('.floater-container');
      floaterContainers.forEach( function(floaterContainer){  
        let topFloaterTl = gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
          scrollTrigger: {
            trigger: floaterContainer,
            start: "top 95%",
            scrub: 0.5
          },
        }),
        floatOne = floaterContainer.querySelectorAll('.images-one.parallax_scroll'),
        floatTwo = floaterContainer.querySelectorAll('.images-twoTop.parallax_scroll')
        ;
        topFloaterTl
            .fromTo(floatOne, 1, { css:{marginTop:70}}, { css:{marginTop:-70}, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeNone})
            .fromTo(floatTwo, 1, { css:{marginTop:110}}, { css:{marginTop:-110}, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeNone}, 0)    

            ;

        let bottomFloaterTrigger =floaterContainer.querySelector('.bottomFloaterTrigger'),
        floatThree = floaterContainer.querySelectorAll('.images-three.parallax_scroll'),
        floatFour = floaterContainer.querySelectorAll('.images-four.parallax_scroll'),  
        floatTwoAlt = floaterContainer.querySelectorAll('.images-twoBtm.parallax_scroll')  
        ;
        let btmFloaterTl = gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
          scrollTrigger: {
            trigger: bottomFloaterTrigger,
            start: "top 90%",
            scrub: 0.5
          },
        });
        btmFloaterTl
            .fromTo(floatThree, 1, { css:{marginBottom:-80}}, { css:{marginBottom:70}, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeNone })
            .fromTo(floatFour, 1, { css:{marginBottom:-80}}, { css:{marginBottom:70}, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeNone }, 0)      
            .fromTo(floatTwoAlt, 1, { css:{marginBottom:-130}}, { css:{marginBottom:130}, ease: gsap__WEBPACK_IMPORTED_MODULE_0__["Quad"].easeNone }, 0) 
            ;
      });
    }

    // PDP Sticky ATC 
    let mainATCButton = document.getElementById('AddToCart');
    let stickyATC = document.querySelector('#Sticky__ATC');
    if(document.body.contains(document.querySelector('#Sticky__ATC'))) {
      gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
        scrollTrigger: {
          trigger: mainATCButton,
          start: "top bottom",
          end: "bottom top",
          onLeave: () => {
              if(stickyATC.classList.contains('conceal')){
                stickyATC.classList.remove('conceal')
              }
            },
          onEnter: () => {
            stickyATC.classList.add('conceal')
            },
          onLeaveBack: () => {
            if(stickyATC.classList.contains('conceal')){
              stickyATC.classList.remove('conceal')
            }
          },
          onEnterBack: () => {
            stickyATC.classList.add('conceal')
          },
        }
      })
      .addLabel("start");
    }

    // Blog Detail STicky Featured Product
    if(document.body.contains(document.querySelector('.recommended-product-mobile'))) {
      let triggerElem = document.querySelector('.article__wrapper'),
      targetElem = document.querySelector('.recommended-product-mobile'),
      targetElemHeight = targetElem.offsetHeight
      ;
      gsap__WEBPACK_IMPORTED_MODULE_0__["gsap"].timeline({
        scrollTrigger: {
          trigger: triggerElem,
          start: "top top",
          end: "max",
          onLeave: () => {
              if(targetElem.classList.contains('sticky')){
                targetElem.classList.remove('sticky')
              }
            },
          onEnter: () => {
            targetElem.classList.add('sticky')
            },
          onLeaveBack: () => {
            if(targetElem.classList.contains('sticky')){
              targetElem.classList.remove('sticky')
            }
          },
          onEnterBack: () => {
            targetElem.classList.add('sticky')
          },
        }
      })
      .addLabel("start");
    }
  }
  
  // 2.0 update on mouse over add class fade now controlled by CSS
  // let altImage = document.querySelectorAll('.productItem__imageWrapper--withAlternateImage');
  // altImage.forEach((item)=>{
  //   item.addEventListener("mouseenter", function() {
  //       item.querySelector(".animate_img").classList.add("image--fadeIn");
  //     });
  //   item.addEventListener("mouseout", function() {
  //       item.querySelector(".animate_img").classList.remove("image--fadeIn");
  //   });
  // },false)
  
  /***/ }),
  
  /***/ "./src/scripts/components/carousel.js":
  /*!********************************************!*\
    !*** ./src/scripts/components/carousel.js ***!
    \********************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Carousel; });
  /* harmony import */ var flickity_css_flickity_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! flickity/css/flickity.css */ "./node_modules/flickity/css/flickity.css");
  /* harmony import */ var flickity_css_flickity_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(flickity_css_flickity_css__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _tools_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tools/responsive */ "./src/scripts/tools/responsive.js");
  var Flickity = __webpack_require__(/*! flickity */ "./node_modules/flickity/js/index.js");
  __webpack_require__(/*! flickity-imagesloaded */ "./node_modules/flickity-imagesloaded/flickity-imagesloaded.js");
  
  
  
  class Carousel {
    constructor(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.element = element;
      if(element !== null && element !== ''){
      this.initialConfig = JSON.parse(element.getAttribute('data-flickity-config'));
      }
      this.options = options;
  
      this._attachListeners();
      this._build();
    }
  
    destroy() {
      this.flickityInstance.destroy();
      if (this.initialConfig['breakpoints'] !== undefined) {
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }
    selectCell(index) {
      var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  
      if (shouldPause) {
        this.flickityInstance.pausePlayer();
      }
  
      this.flickityInstance.select(index, false, !shouldAnimate);
    }
    pausePlayer() {
      this.flickityInstance.pausePlayer();
    }
    unpausePlayer() {
      this.flickityInstance.unpausePlayer();
    }
    resize() {
      this.flickityInstance.resize();
    }
    getSelectedIndex() {
      return this.flickityInstance.selectedIndex;
    }
    getSelectedCell() {
      return this.flickityInstance.selectedCell.element;
    }
    _attachListeners() {
      if (this.initialConfig['breakpoints'] !== undefined) {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }
  
    /**
     * Create the carousel instance
     */
  
    _build() {
      var _this = this;
  
      var config = this._processConfig();
  
      this.flickityInstance = new Flickity(this.element, config);
      this._validateDraggable();
  
      this.selectedIndex = this.flickityInstance.selectedIndex;
  
      this.flickityInstance.on('resize', this._validateDraggable.bind(this));
  
      if (this.options['onSelect']) {
        this.flickityInstance.on('select', function () {
          // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
          // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
  
          if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
            _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
            _this.selectedIndex = _this.flickityInstance.selectedIndex;
          }
        });
      }
  
      if (this.options['onClick']) {
        this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
          _this.options['onClick'](cell, index);
        });
      }
    }
  
    /**
     * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
     * if the displayed elements equals to the amount of elements
     */
  
    _validateDraggable() {
      var isActive = this.flickityInstance.isActive || false;
      this.resize.bind(this);
      if (!isActive || !this.flickityInstance.options['draggable']) {
        return; // Not draggable, so nothing to do
      }
  
      if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
        this.flickityInstance.unbindDrag();
      } else {
        this.flickityInstance.bindDrag();
      }
    }
  
    /**
     * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
     */
  
    _processConfig() {
      var config = Object.assign({}, this.initialConfig);
  
      delete config['breakpoints'];
  
      if (this.initialConfig['breakpoints'] === undefined) {
        return config; // No change, we simply return the config as it is
      }
  
      var breakpoints = this.initialConfig['breakpoints'];
  
      breakpoints.forEach(function (breakpoint) {
        if (_tools_responsive__WEBPACK_IMPORTED_MODULE_1__["default"].matchesBreakpoint(breakpoint['matches'])) {
          config = Object.assign(config, breakpoint['settings']);
        }
      });
  
      return config;
    }
  
    /**
     * Verify if the breakpoint has changed, and optionally update the carousel
     */
  
    _onBreakpointChanged() {
      // The breakpoint may have changed, so we delete the carousel and rebuild it
      this.flickityInstance.destroy();
      this._build();
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/cart-section.js":
  /*!************************************************!*\
    !*** ./src/scripts/components/cart-section.js ***!
    \************************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CartSection; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
  /* harmony import */ var _drawer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./drawer */ "./src/scripts/components/drawer.js");
  /* harmony import */ var _tools_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tools/dom */ "./src/scripts/tools/dom.js");
  /* harmony import */ var _shipping_estimator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./shipping-estimator */ "./src/scripts/components/shipping-estimator.js");
  /* harmony import */ var _tools_currency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../tools/currency */ "./src/scripts/tools/currency.js");
  
  
  
  
  
  
  
  
  class CartSection {
    constructor(container) {
  
      this.element = container;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];
      this.isCartNoteOpen = false;
  
      if (this.options['drawer']) {
        this.sidebarDrawer = new _drawer__WEBPACK_IMPORTED_MODULE_2__["default"](this.element, {
          onClose: this._onDrawerClosed.bind(this)
        });
      }
  
      if (this.options['hasShippingEstimator']) {
        this.shippingEstimator = new _shipping_estimator__WEBPACK_IMPORTED_MODULE_4__["default"](this.element.querySelector('.shippingEstimator'));
      }
  
      this._attachListeners();
    }
  
    onUnload() {
      if (this.options['hasShippingEstimator']) {
        this.shippingEstimator.destroy();
      }
  
      this.delegateElement.off();
      document.removeEventListener('product:added', this._onProductAddedListener);
    }
    _attachListeners() {
      this._onProductAddedListener = this._onProductAdded.bind(this);
  
      this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));
  
      if (this.options['type'] !== 'page') {
        this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
        this.delegateElement.on('change', '.quantitySelector__currentQuantity', this._updateItemQuantity.bind(this));
      } else {
        this.delegateElement.on('change', '.quantitySelector__currentQuantity', this._reloadPageWithQuantity.bind(this));
      }
  
      // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page
      if (this.options['drawer']) {
        this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
      }
  
      document.addEventListener('product:added', this._onProductAddedListener);
    }
    _updateCartNote(event, target) {
      fetch('/cart/update.js', {
        body: JSON.stringify({ note: target.value }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      });
    }
    _toggleCartNote() {
      var _this29 = this;
  
      var noteContainer = this.element.querySelector('.cart__offscreenNoteContainer'),
          cartNote = this.element.querySelector('#cart-note');
  
      this.element.classList.toggle('has-note-open');
      this.element.querySelector('.cart__noteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
  
      noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
  
      this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';
  
      if (this.element.classList.contains('has-note-open')) {
        var transitionEndListener = function transitionEndListener() {
          _this29.element.querySelector('#cart-note').focus();
          noteContainer.removeEventListener('transitionend', transitionEndListener);
        };
  
        noteContainer.addEventListener('transitionend', transitionEndListener);
      }
    }
    _updateItemQuantity(event, target) {
      var _this30 = this;
  
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      var quantity = null,
          elementToAnimate = null;
  
      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        quantity = parseInt(target.getAttribute('data-quantity'));
      }
  
      // If the quantity is 0, then we will animate the product with a removal effect
      if (quantity === 0) {
        elementToAnimate = target.closest('.cartItemWrapper');
      }
  
      fetch('/cart/change.js', {
        body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: quantity }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this30.itemCount = content['item_count'];
          _this30._rerenderCart(elementToAnimate);
  
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
  
      event.preventDefault();
    }
    _reloadPageWithQuantity(event, target) {
      window.location.href = '/cart/change?quantity=' + parseInt(target.value) + '&id=' + target.getAttribute('data-line-id');
    }
    _onProductAdded(event) {
      var _this31 = this;
      this.itemCount += event.detail.quantity;
  
      this._rerenderCart().then(function () {
        _this31.sidebarDrawer.open();
      });
    }
    _onDrawerClosed() {
      if (this.isCartNoteOpen) {
        this._toggleCartNote();
      }
    }
  
    /**
     * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
     * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
     * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
     * all the time and hence having easier logic.
     */
  
    _rerenderCart(elementToAnimate) {
      var _this32 = this;
  
      // The only thing that we do in JavaScript is checking that if there are no items, we remove the dot in the header
      // and change the cart count in the header
      var cartDot = _tools_dom__WEBPACK_IMPORTED_MODULE_3__["default"].nodeListToArray(document.querySelectorAll('.header__cartDot')),
          cartQuantity = _tools_dom__WEBPACK_IMPORTED_MODULE_3__["default"].nodeListToArray(document.querySelectorAll('.header__cartCount'));
  
      cartDot.forEach(function (item) {
        if (_this32.itemCount === 0) {
          item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.add('is-visible');
        }
      });
  
      cartQuantity.forEach(function (item) {
        item.textContent = _this32.itemCount;
      });
  
      // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
      return fetch('/cart?view=' + (this.options['drawer'] ? 'drawer' : 'ajax') + '&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        // If there is an element to animate, we animate it using a transition
        if (_this32.options['drawer'] && elementToAnimate) {
          var timeline = gsap__WEBPACK_IMPORTED_MODULE_1__["default"].timeline({ onComplete: function onComplete() {
              content.text().then(function (html) {
                _this32._replaceContent(html);
              });
            } });
  
          timeline.to(elementToAnimate, 0.5, { height: 0, opacity: 0, ease: gsap__WEBPACK_IMPORTED_MODULE_1__["Cubic"].easeOut }, 0);
  
          if (_this32.itemCount === 0) {
            timeline.to(_this32.element.querySelector('.drawer__footer'), 0.5, { y: '100%', transition: 'none', ease: gsap__WEBPACK_IMPORTED_MODULE_1__["Cubic"].easeInOut }, 0);
          }
        } else {
          content.text().then(function (html) {
            _this32._replaceContent(html);
          });
        }
      });
    }
    _replaceContent(html) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      
  
      // Convert in background
      if (window.theme.currencyConversionEnabled) {
        _tools_currency__WEBPACK_IMPORTED_MODULE_5__["default"].convertAll(tempElement);
      }
  
      var cartNodeParent = this.element.querySelector('.cart').parentNode;
  
      if (this.options['drawer']) {
        var currentScrollPosition = this.element.querySelector('.drawer__main').scrollTop;
        cartNodeParent.replaceChild(tempElement.querySelector('.cart'), this.element.querySelector('.cart'));
        this.element.querySelector('.drawer__main').scrollTop = currentScrollPosition;
      } else {
        // For dedicated page we replace the whole section if there is no more product
        if (this.itemCount === 0) {
          this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
        } else {
          cartNodeParent.replaceChild(tempElement.querySelector('.cart'), this.element.querySelector('.cart'));
          this.element.querySelector('.pageHeader').innerHTML = tempElement.querySelector('.pageHeader').innerHTML;
        }
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/cart.js":
  /*!****************************************!*\
    !*** ./src/scripts/components/cart.js ***!
    \****************************************/
  /*! no exports provided */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
  /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_1__);
  
  
  
  
  let delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_1___default.a(document.querySelector('body'))
  let notificationElm = document.querySelector('#shopify-section-notification')
  let notificationCntElm = notificationElm.querySelector('.notificationBar__content')
  let notificationTimeout
  
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart.requestComplete', function(event, cart) {
    notificationElm.classList.remove('is-visible')
      document
        .querySelector(".drawer-overlay")
        .setAttribute("aria-hidden", "false")
      jquery__WEBPACK_IMPORTED_MODULE_0___default()("#sidebar-cart").attr("aria-hidden", "false")
  });
  
  // Create event handler for failed addition.
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).ajaxError(function(event, jqxhr, settings, thrownError) {
    if (settings.url == "/cart.js") {
      // GET /cart.js error
    } else if (settings.url.indexOf("/cart/") !== -1) {
      notificationElm.classList.add('is-visible')
      clearTimeout(notificationTimeout)
      notificationTimeout = setTimeout(() =>{
          notificationElm.classList.remove('is-visible')
      },15000)
      if (settings.url == "/cart/add.js") {
        //   POST cart/add.js error
        if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
          notificationCntElm.innerHTML = 'Add to cart failed. Please try again.'
        } else {
          notificationCntElm.innerHTML = jqxhr.responseJSON.description
        }
      }
      if (settings.url == "/cart/update.js") {
        //   POST cart/update.js error'
        if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
          notificationCntElm.innerHTML = 'Update to cart failed. Please try again.'
        } else {
          notificationCntElm.innerHTML = jqxhr.responseJSON.description
        }
      }
      if (settings.url == "/cart/change.js") {
        //   POST cart/change.js error
        if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
          notificationCntElm.innerHTML = 'Change to cart failed. Please try again.'
        } else {
          notificationCntElm.innerHTML = jqxhr.responseJSON.description
        }
      }
      if (settings.url == "/cart/clear.js") {
        //   POST cart/clear.js error
        if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
          notificationCntElm.innerHTML = 'Clear to cart failed. Please try again.'
        } else {
          notificationCntElm.innerHTML = jqxhr.responseJSON.description
        }
      }
    } else {
      // NOT CART AJAX
    }
  })
  
  delegateElement.on('click', '[data-action="close-notification"]', function () {
      notificationElm.classList.remove('is-visible')
  })
  var renderNewCartJSView = function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-cart-barba]').each(function() {
      var view = rivets.bind(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), CartJS.Rivets.model);
      CartJS.Rivets.boundViews.push(view);
    });
  }
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.productForm').each(function() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).submit(function(event){
      let form = this
      event.preventDefault()
    })
  })
  
  /***/ }),
  
  /***/ "./src/scripts/components/collapsible.js":
  /*!***********************************************!*\
    !*** ./src/scripts/components/collapsible.js ***!
    \***********************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Collapsible; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _tools_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tools/responsive */ "./src/scripts/tools/responsive.js");
  /* harmony import */ var _tools_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tools/dom */ "./src/scripts/tools/dom.js");
  /* harmony import */ var _tools_animation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tools/animation */ "./src/scripts/tools/animation.js");
  
  
  
  
  
  
  class Collapsible {
    constructor() {
      this.domDelegate = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(document.body);
      this._attachListeners();
    }
  
    _attachListeners() {
      this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
    }
  
    /**
     * Toggle a given collapsible
     */
  
    _toggleCollapsible(event, target) {
      var _this14 = this;
  
      // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
      var parentCollapsible = target.closest('.collapsible');
  
      if (parentCollapsible.classList.contains('collapsible--autoExpand') && _tools_responsive__WEBPACK_IMPORTED_MODULE_1__["default"].matchesBreakpoint('tablet-and-up')) {
        return;
      }
  
      var isOpen = target.getAttribute('aria-expanded') === 'true';
  
      if (isOpen) {
        this._close(parentCollapsible, target);
      } else {
        this._open(parentCollapsible, target);
      }
  
      // We make sure to close any siblings collapsible as well
      _tools_dom__WEBPACK_IMPORTED_MODULE_2__["default"].getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
        return _this14._close(collapsibleToClose);
      });
      event.preventDefault();
    }
  
    /**
     * Open a given collapsible
     */
  
    _open(collapsible) {
      var toggleButton = collapsible.querySelector('.collapsible__button'),
          collapsibleInner = collapsible.querySelector('.collapsible__inner');
  
      if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
        return; // It's already open
      }
  
      toggleButton.setAttribute('aria-expanded', 'true');
      collapsibleInner.style.overflow = 'visible';
      _tools_animation__WEBPACK_IMPORTED_MODULE_3__["default"].slideDown(collapsibleInner);
    }
  
    /**
     * Close a given collapsible
     */
  
    _close(collapsible) {
      var toggleButton = collapsible.querySelector('.collapsible__button'),
          collapsibleInner = collapsible.querySelector('.collapsible__inner');
  
      if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
        return; // It's already closed
      }
  
      toggleButton.setAttribute('aria-expanded', 'false');
      collapsibleInner.style.overflow = 'hidden';
      _tools_animation__WEBPACK_IMPORTED_MODULE_3__["default"].slideUp(collapsibleInner);
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/country-selector.js":
  /*!****************************************************!*\
    !*** ./src/scripts/components/country-selector.js ***!
    \****************************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CountrySelector; });
  class CountrySelector {
    constructor(countrySelect, provinceSelect) {
      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;
  
      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();
        this._initSelectors();
      }
    }
  
    destroy() {
      if (this.countrySelect) {
        this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
      }
    }
    _initSelectors() {
      // Check first the default value of country
      var defaultCountry = this.countrySelect.getAttribute('data-default');
  
      if (defaultCountry) {
        for (var i = 0; i !== this.countrySelect.options.length; ++i) {
          if (this.countrySelect.options[i].text === defaultCountry) {
            this.countrySelect.selectedIndex = i;
            break;
          }
        }
      } else {
        this.countrySelect.selectedIndex = 0;
      }
  
      var event = new Event('change', { bubbles: true });
      this.countrySelect.dispatchEvent(event);
  
      // Then the province
      var defaultProvince = this.provinceSelect.getAttribute('data-default');
  
      if (defaultProvince) {
        this.provinceSelect.value = defaultProvince;
      }
    }
    _attachListeners() {
      this._onCountryChangedListener = this._onCountryChanged.bind(this);
      this.countrySelect.addEventListener('change', this._onCountryChangedListener);
    }
    _onCountryChanged() {
      var _this9 = this;
  
      var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
          provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');
  
      // First remove all options
      this.provinceSelect.innerHTML = '';
  
      if (provinces.length === 0) {
        this.provinceSelect.parentNode.style.display = 'none';
        return;
      }
  
      // We need to build the provinces array
      provinces.forEach(function (data) {
        _this9.provinceSelect.options.add(new Option(data[1], data[0]));
      });
  
      this.provinceSelect.parentNode.style.display = 'block';
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/drawer.js":
  /*!******************************************!*\
    !*** ./src/scripts/components/drawer.js ***!
    \******************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Drawer; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _tools_accessibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tools/accessibility */ "./src/scripts/tools/accessibility.js");
  
  
  
  
  class Drawer {
    constructor(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  
      this.element = element;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
      this.delegateBody = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(document.body);
  
      this.onOpen = options['onOpen'] || function () {};
      this.onClose = options['onClose'] || function () {};
  
      this.isOpen = false;
      this.direction = this.element.classList.contains('drawer--fromLeft') ? 'fromLeft' : 'fromRight';
  
      this.pageOverlayElement = document.querySelector('.pageOverlay');
  
      this._attachListeners();
    }
  
    destroy() {
      this.delegateBody.off('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
      this.delegateBody.off('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]');
      window.removeEventListener('resize', this._calculateMaxHeightListener);
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    open(event) {
      if (this.isOpen) {
        return;
      }
  
      if (event) {
        event.preventDefault();
      }
  
      this.element.setAttribute('aria-hidden', 'false');
      this._calculateMaxHeight();
  
      document.documentElement.classList.add('no-scroll');
  
      // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
      // other browsers, this is the only way to achieve that
      // disableBodyScroll(true, '[data-scrollable]');
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_1__["default"].trapFocus(this.element, 'drawer');
  
      // We attach an event to the page overlay to close it
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this._closeListener);
  
      this.isOpen = true;
  
      this.onOpen(); // Call the callback to allow other code to hook their logic
  
      return false;
    }
    close(event) {
      if (!this.isOpen) {
        return;
      }
  
      if (event) {
        event.preventDefault();
      }
  
      this.element.setAttribute('aria-hidden', 'true');
  
      document.documentElement.classList.remove('no-scroll');
  
      // disableBodyScroll(false, '[data-scrollable]');
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_1__["default"].removeTrapFocus(this.element, 'drawer');
  
      this.pageOverlayElement.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener('click', this._closeListener);
  
      this.isOpen = false;
  
      this.onClose(); // Call the callback to allow other code to hook their logic
    }
    _attachListeners() {
      this._openListener = this.open.bind(this);
      this._closeListener = this.close.bind(this);
      this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
  
      this.delegateBody.on('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]', this._openListener);
      this.delegateBody.on('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]', this._closeListener);
      this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
      window.addEventListener('resize', this._calculateMaxHeightListener);
    }
  
    /**
     * Make sure that we force a max-height so that the drawer always stays on screen
     */
  
    _calculateMaxHeight() {
      this.element.style.maxHeight = window.innerHeight + 'px';
    }
  
    /**
     * Handle a11y events
     */
    _handleKeyboard(event) {
      if (this.isOpen && event.keyCode === 27) {
        this.close();
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/iframe.js":
  /*!******************************************!*\
    !*** ./src/scripts/components/iframe.js ***!
    \******************************************/
  /*! no static exports found */
  /***/ (function(module, exports) {
  
  Array.from(document.querySelectorAll('.rte iframe')).forEach(function (iframe) {
      // We scope the wrapping only for YouTube and Vimeo
      if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
        iframe.outerHTML = '<div class="videoWrapper">' + iframe.outerHTML + '</div>';
  
        // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
        iframe.src = iframe.src;
      }
  })
  
  /***/ }),
  
  /***/ "./src/scripts/components/mediabox.js":
  /*!********************************************!*\
    !*** ./src/scripts/components/mediabox.js ***!
    \********************************************/
  /*! no exports provided */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony import */ var mediabox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mediabox */ "./node_modules/mediabox/dist/mediabox.js");
  /* harmony import */ var mediabox__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mediabox__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var mediabox_src_mediabox_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mediabox/src/mediabox.css */ "./node_modules/mediabox/src/mediabox.css");
  /* harmony import */ var mediabox_src_mediabox_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mediabox_src_mediabox_css__WEBPACK_IMPORTED_MODULE_1__);
  
  
  
  mediabox__WEBPACK_IMPORTED_MODULE_0___default()('.mediabox'); // Additional options
  
  /***/ }),
  
  /***/ "./src/scripts/components/modal.js":
  /*!*****************************************!*\
    !*** ./src/scripts/components/modal.js ***!
    \*****************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Modal; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var fastdom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! fastdom */ "./node_modules/fastdom/fastdom.js");
  /* harmony import */ var fastdom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fastdom__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */ var _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tools/accessibility */ "./src/scripts/tools/accessibility.js");
  
  
  
  
  
  class Modal {
    constructor() {
      this.domDelegate = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(document.body);
      this.activeModal = null; // Keep track of the active modal
      this.wasLocked = false;
  
      this.pageOverlayElement = document.querySelector('.pageOverlay');
  
      this._attachListeners();
      this._checkOpenByHash();
    }
  
    _attachListeners() {
      this._closeListener = this._closeModal.bind(this);
      this._handleKeyboardListener = this._handleKeyboard.bind(this);
  
      this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
      this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
    }
    _openModalEvent(event, target) {
      this._openModal(document.getElementById(target.getAttribute('aria-controls')));
      event.preventDefault();
      event.stopPropagation();
    }
    _openModal(modal) {
      var _this15 = this;
  
      if (this.activeModal || !modal) {
        return; // If there is already an open modal, we return as we only allows one modal at a time
      }
  
      this.activeModal = modal;
      this.domDelegate.on('keyup', this._handleKeyboardListener);
      console.log(document.documentElement);
      if (document.documentElement.classList.contains('no-scroll')) {
        this.wasLocked = true;
      }
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].clearTrapFocus(); // Needed as the modal can be open on top of a popover
  
        _this15._onTransitionEndedListener = _this15._onTransitionEnded.bind(_this15);
        _this15.activeModal.addEventListener('transitionend', _this15._onTransitionEndedListener);
  
        _this15.activeModal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
  
        // If the modal is not a fullscreen modal, then we also display the overlay
        if (!_this15.activeModal.classList.contains('modal--fullScreen')) {
          _this15.pageOverlayElement.classList.add('is-visible');
          _this15.pageOverlayElement.addEventListener('click', _this15._closeListener);
        }
      });
    }
    _closeModal() {
      var _this16 = this;
  
      if (!this.activeModal) {
        return; // If no modal are open, we return immediately
      }
  
      this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
      this.domDelegate.off('keyup');
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        // If the modal is of video type, we need to remove the iframe to stop the video
        if (_this16.activeModal.classList.contains('modal--videoContent')) {
          _this16._resetVideoListener = _this16._resetVideo.bind(_this16);
          _this16.activeModal.addEventListener('transitionend', _this16._resetVideoListener);
        }
  
        _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].removeTrapFocus(_this16.activeModal, 'modal');
  
        if (!_this16.activeModal.classList.contains('modal--fullScreen')) {
          _this16.pageOverlayElement.classList.remove('is-visible');
          _this16.pageOverlayElement.removeEventListener('click', _this16._closeListener);
        }
  
        _this16.activeModal.setAttribute('aria-hidden', 'true');
        _this16.activeModal = null;
  
        if (!_this16.wasLocked) {
          document.documentElement.classList.remove('no-scroll');
        }
      });
    }
    _onTransitionEnded(event) {
      if (event.propertyName !== 'visibility') {
        return;
      }
  
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)
  
      this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
    }
    _resetVideo(event) {
      if (event.propertyName !== 'visibility') {
        return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
      }
  
      var iframe = event.target.querySelector('iframe');
      iframe.parentNode.innerHTML = '<iframe class="image--lazyLoad" data-src=' + iframe.getAttribute('data-src') + ' frameborder="0" allowfullscreen>';
  
      event.target.removeEventListener('transitionend', this._resetVideoListener);
    }
  
    /**
     * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
     */
  
    _checkOpenByHash() {
      var hash = window.location.hash,
          modal = document.getElementById(hash.replace('#', ''));
  
      if (modal && modal.classList.contains('modal')) {
        this._openModal(modal);
      }
    }
  
    /**
     * Handle a11y events
     */
  
    _handleKeyboard(event) {
      if (null !== this.activeModal && event.keyCode === 27) {
        this._closeModal();
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/popover.js":
  /*!*******************************************!*\
    !*** ./src/scripts/components/popover.js ***!
    \*******************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Popover; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _tools_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tools/dom */ "./src/scripts/tools/dom.js");
  /* harmony import */ var _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tools/accessibility */ "./src/scripts/tools/accessibility.js");
  /* harmony import */ var _tools_responsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tools/responsive */ "./src/scripts/tools/responsive.js");
  
  
  
  
  
  
  class Popover {
    constructor (element, options) {
  
      this.element = element;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
  
      this.activator = options['activator'] || document.querySelector('[aria-controls="' + element.getAttribute('id') + '"]');
      this.preferredPosition = options['preferredPosition'] || 'bottom';
      this.isOpen = false;
  
      this.onValueChanged = options['onValueChanged'] || function () {};
      this.onOpen = options['onOpen'] || function () {};
      this.onClose = options['onClose'] || function () {};
  
      this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
      this.pageOverlayElement = document.querySelector('.pageOverlay');
  
      this._attachListeners();
    }
  
    destroy() {
      this.element.removeEventListener('keyup', this._handleKeyboardListener);
      this.delegateElement.off('click');
      this.activator.removeEventListener('click', this._toggleListener);
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    open() {
      // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
      //       popovers and be modified dynamically in JavaScript
      if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
        return;
      }
  
      this.element.setAttribute('aria-hidden', 'false');
      this.activator.setAttribute('aria-expanded', 'true');
  
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].trapFocus(this.element, 'popover');
  
  
      document.documentElement.classList.add('no-scroll-popover'); // Prevent scrolling when popover is open
  
      if (_tools_responsive__WEBPACK_IMPORTED_MODULE_3__["default"].matchesBreakpoint('lg')) {
        document.body.addEventListener('click', this._clickOutsideListener);
        this._position();
      } else {
        this.element.removeAttribute('style');
  
        if (this.showOverlay) {
          this.pageOverlayElement.classList.add('is-visible');
          this.pageOverlayElement.addEventListener('click', this._closeListener);
        }
      }
  
      this.onOpen(this); // Call the callback to allow other code to hook their logic
      this.isOpen = true;
    }
    close() {
      if (!this.isOpen) {
        return;
      }
  
      this.element.setAttribute('aria-hidden', 'true');
      this.activator.setAttribute('aria-expanded', 'false');
  
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].removeTrapFocus(this.element, 'popover');
      // disableBodyScroll(false, '[data-scrollable]');
  
      document.documentElement.classList.remove('no-scroll-popover');
  
      if (_tools_responsive__WEBPACK_IMPORTED_MODULE_3__["default"].matchesBreakpoint('lg')) {
        document.body.removeEventListener('click', this._clickOutsideListener);
      } else if (this.showOverlay) {
        this.pageOverlayElement.classList.remove('is-visible');
        this.pageOverlayElement.removeEventListener('click', this._closeListener);
      }
  
      this.onClose(this); // Call the callback to allow other code to hook their logic
      this.isOpen = false;
    }
    _attachListeners() {
      this._handleKeyboardListener = this._handleKeyboard.bind(this);
      this._clickOutsideListener = this._clickOutside.bind(this);
      this._closeListener = this.close.bind(this);
      this._toggleListener = this.toggle.bind(this);
  
      this.element.addEventListener('keyup', this._handleKeyboardListener);
      this.activator.addEventListener('click', this._toggleListener);
  
      this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
      this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));
    }
  
    /**
     * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
     * of the value change
     */
  
    _valueChanged(event) {
      _tools_dom__WEBPACK_IMPORTED_MODULE_1__["default"].getSiblings(event.target, '.is-selected').forEach(function (item) {
        return item.classList.remove('is-selected');
      });
      event.target.classList.add('is-selected');
  
      // If there is a callback in option we call it with the value
      this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
      this.close();
    }
  
    /**
     * Callback that is called to decide if we should close the popover when a click is captured outside
     */
  
    _clickOutside(event) {
      if (!event.target.closest('.popover') && !event.target.closest('.modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
        this.close();
      }
    }
  
    /**
     * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
     */
  
    _position() {
      var _this4 = this;
  
      var topPosition = 0,
          rightPosition = 0,
          position = '',
          alignment = '',
          threshold = 0;
  
      fastdom.measure(function () {
        var windowHeight = window.innerHeight,
            activatorBoundingRect = _this4.activator.getBoundingClientRect(),
            halfHeight = windowHeight / 2;
  
        if (_this4.preferredPosition === 'bottom') {
          alignment = 'right';
  
          if (_this4.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
            position = 'bottom';
          } else {
            position = 'top';
          }
        } else if (_this4.preferredPosition === 'top') {
          alignment = 'right';
  
          if (_this4.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
            position = 'top';
          } else {
            position = 'bottom';
          }
        } else {
          position = 'left';
  
    
          var halfElementHeight = _this4.element.clientHeight / 2;
  
          if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
            alignment = 'center';
          } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
            alignment = 'bottom';
          } else {
            alignment = 'top';
          }
        }
  
        if (position === 'top') {
          topPosition = activatorBoundingRect.top - _this4.element.clientHeight - threshold;
          rightPosition = window.innerWidth - activatorBoundingRect.right;
        } else if (position === 'bottom') {
          topPosition = activatorBoundingRect.bottom + threshold;
          rightPosition = document.documentElement.clientWidth - activatorBoundingRect.right;
          
        } else {
          rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
  
          if (alignment === 'center') {
            topPosition = activatorBoundingRect.top - _this4.element.clientHeight / 2 + _this4.activator.clientHeight / 2;
          } else if (alignment === 'top') {
            topPosition = activatorBoundingRect.bottom - _this4.element.clientHeight;
          } else {
            topPosition = activatorBoundingRect.top;
          }
        }
      });
  
      fastdom.mutate(function () {
        ['popover--positionBottom', 'popover--positionTop', 'popover--positionCenter', 'popover--alignTop', 'popover--alignCenter', 'popover--alignBottom'].map(function (item) {
          return _this4.element.classList.remove(item);
        });
        _this4.element.classList.add('popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
        _this4.element.classList.add('popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));
  
        _this4.element.setAttribute('style', 'top: ' + parseInt(topPosition) + 'px; right: ' + '0px;');
      });
    }
  
    /**
     * Handle a11y events
     */
  
    _handleKeyboard(event) {
      if (this.isOpen && event.keyCode === 27) {
        this.close();
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/popup.js":
  /*!*****************************************!*\
    !*** ./src/scripts/components/popup.js ***!
    \*****************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Popover; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _tools_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tools/dom */ "./src/scripts/tools/dom.js");
  /* harmony import */ var _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tools/accessibility */ "./src/scripts/tools/accessibility.js");
  /* harmony import */ var _tools_responsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tools/responsive */ "./src/scripts/tools/responsive.js");
  
  
  
  
  
  
  class Popover {
    constructor (element, options) {
  
      this.element = element;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
  
      this.activator = options['activator'] || document.querySelector('[aria-controls="' + element.getAttribute('id') + '"]');
      this.preferredPosition = options['preferredPosition'] || 'bottom';
      this.isOpen = false;
  
      this.onValueChanged = options['onValueChanged'] || function () {};
      this.onOpen = options['onOpen'] || function () {};
      this.onClose = options['onClose'] || function () {};
  
      this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
      this.pageOverlayElement = document.querySelector('.pageOverlay');
  
      this._attachListeners();
    }
  
    destroy() {
      this.element.removeEventListener('keyup', this._handleKeyboardListener);
      this.delegateElement.off('click');
      this.activator.removeEventListener('click', this._toggleListener);
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    open() {
      // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
      //       popovers and be modified dynamically in JavaScript
      if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
        return;
      }
  
      this.element.setAttribute('aria-hidden', 'false');
      this.activator.setAttribute('aria-expanded', 'true');
  
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].trapFocus(this.element, 'popover');
      // disableBodyScroll(true, '[data-scrollable]');
  
      document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open
  
      if (_tools_responsive__WEBPACK_IMPORTED_MODULE_3__["default"].matchesBreakpoint('lg')) {
        document.body.addEventListener('click', this._clickOutsideListener);
        this._position();
      } else {
        this.element.removeAttribute('style');
  
        if (this.showOverlay) {
          this.pageOverlayElement.classList.add('is-visible');
          this.pageOverlayElement.addEventListener('click', this._closeListener);
        }
      }
  
      this.onOpen(this); // Call the callback to allow other code to hook their logic
      this.isOpen = true;
    }
    close() {
      if (!this.isOpen) {
        return;
      }
  
      this.element.setAttribute('aria-hidden', 'true');
      this.activator.setAttribute('aria-expanded', 'false');
  
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_2__["default"].removeTrapFocus(this.element, 'popover');
      // disableBodyScroll(false, '[data-scrollable]');
  
      document.documentElement.classList.remove('no-scroll');
  
      if (_tools_responsive__WEBPACK_IMPORTED_MODULE_3__["default"].matchesBreakpoint('lg')) {
        document.body.removeEventListener('click', this._clickOutsideListener);
      } else if (this.showOverlay) {
        this.pageOverlayElement.classList.remove('is-visible');
        this.pageOverlayElement.removeEventListener('click', this._closeListener);
      }
  
      this.onClose(this); // Call the callback to allow other code to hook their logic
      this.isOpen = false;
    }
    _attachListeners() {
      this._handleKeyboardListener = this._handleKeyboard.bind(this);
      this._clickOutsideListener = this._clickOutside.bind(this);
      this._closeListener = this.close.bind(this);
      this._toggleListener = this.toggle.bind(this);
  
      this.element.addEventListener('keyup', this._handleKeyboardListener);
      this.activator.addEventListener('click', this._toggleListener);
  
      this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
      this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));
    }
  
    /**
     * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
     * of the value change
     */
  
    _valueChanged(event) {
      _tools_dom__WEBPACK_IMPORTED_MODULE_1__["default"].getSiblings(event.target, '.is-selected').forEach(function (item) {
        return item.classList.remove('is-selected');
      });
      event.target.classList.add('is-selected');
  
      // If there is a callback in option we call it with the value
      this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
      this.close();
    }
  
    /**
     * Callback that is called to decide if we should close the popover when a click is captured outside
     */
  
    _clickOutside(event) {
      if (!event.target.closest('.popover') && !event.target.closest('.modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
        this.close();
      }
    }
  
    /**
     * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
     */
  
    _position() {
      var _this4 = this;
  
      var topPosition = 0,
          rightPosition = 0,
          position = '',
          alignment = '',
          threshold = 20;
  
      fastdom.measure(function () {
        var windowHeight = window.innerHeight,
            activatorBoundingRect = _this4.activator.getBoundingClientRect(),
            halfHeight = windowHeight / 2;
  
        if (_this4.preferredPosition === 'bottom') {
          alignment = 'right';
  
          if (_this4.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
            position = 'bottom';
          } else {
            position = 'top';
          }
        } else if (_this4.preferredPosition === 'top') {
          alignment = 'right';
  
          if (_this4.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
            position = 'top';
          } else {
            position = 'bottom';
          }
        } else {
          position = 'left';
  
          // Is there enough space to use the center alignment (which is preferred)?
          var halfElementHeight = _this4.element.clientHeight / 2;
  
          if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
            alignment = 'center';
          } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
            alignment = 'bottom';
          } else {
            alignment = 'top';
          }
        }
  
        if (position === 'top') {
          topPosition = activatorBoundingRect.top - _this4.element.clientHeight - threshold;
          rightPosition = window.innerWidth - activatorBoundingRect.right;
        } else if (position === 'bottom') {
          topPosition = activatorBoundingRect.bottom + threshold;
          rightPosition = window.innerWidth - activatorBoundingRect.right;
        } else {
          rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
  
          if (alignment === 'center') {
            topPosition = activatorBoundingRect.top - _this4.element.clientHeight / 2 + _this4.activator.clientHeight / 2;
          } else if (alignment === 'top') {
            topPosition = activatorBoundingRect.bottom - _this4.element.clientHeight;
          } else {
            topPosition = activatorBoundingRect.top;
          }
        }
      });
  
      fastdom.mutate(function () {
        ['popover--positionBottom', 'popover--positionTop', 'popover--positionCenter', 'popover--alignTop', 'popover--alignCenter', 'popover--alignBottom'].map(function (item) {
          return _this4.element.classList.remove(item);
        });
        _this4.element.classList.add('popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
        _this4.element.classList.add('popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));
  
        _this4.element.setAttribute('style', 'top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
      });
    }
  
    /**
     * Handle a11y events
     */
  
    _handleKeyboard(event) {
      if (this.isOpen && event.keyCode === 27) {
        this.close();
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/search-bar.js":
  /*!**********************************************!*\
    !*** ./src/scripts/components/search-bar.js ***!
    \**********************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SearchBar; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _tools_accessibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tools/accessibility */ "./src/scripts/tools/accessibility.js");
  
  
  
  
  class SearchBar {
    constructor() {
      this.documentDelegate = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(document.body);
  
      this.searchElement = document.getElementById('search');
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement = this.searchElement.querySelector('.search__results');
      this.queryMap = {};
      this.isOpen = false;
  
      this.pageOverlayElement = document.querySelector('.pageOverlay');
  
      this._attachListeners();
    }
  
    destroy() {
      this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
      this.searchInputElement.removeEventListener('input', this._onInputListener);
  
      this.documentDelegate.off();
    }
    _attachListeners() {
      this._preventSubmissionListener = this._preventSubmission.bind(this);
      this._onInputListener = this._debounce(this._onInput.bind(this), 250);
  
      this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
      this.searchInputElement.addEventListener('input', this._onInputListener);
  
      this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
      this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
      this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
    }
  
    /**
     * Toggle the search
     */
  
    _toggleSearch(event) {
      if (this.isOpen) {
        this._closeSearch(event);
      } else {
        this._openSearch(event);
      }
  
      event.preventDefault();
    }
  
    /**
     * Open the search form and trap focus
     */
  
    _openSearch() {
      var _this17 = this;
  
      this.searchElement.setAttribute('aria-hidden', 'false');
  
      document.documentElement.classList.add('no-scroll');
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_1__["default"].trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));
  
      var onFocusListener = function onFocusListener() {
        _this17.searchInputElement.focus();
        _this17.searchElement.removeEventListener('transitionend', onFocusListener);
      };
  
      this.searchElement.addEventListener('transitionend', onFocusListener);
      this.isOpen = true;
  
      this.pageOverlayElement.classList.add('is-visible');
      document.querySelector('#shopify-section-header').style.zIndex = 10;
    }
  
    /**
     * Close the search form and clear focus
     */
  
    _closeSearch() {
      var _this18 = this;
  
      this.searchElement.setAttribute('aria-hidden', 'true');
  
      document.documentElement.classList.remove('no-scroll');
      _tools_accessibility__WEBPACK_IMPORTED_MODULE_1__["default"].removeTrapFocus(this.searchElement, 'search');
  
      this.isOpen = false;
  
      var onTransitionEnd = function onTransitionEnd(event) {
        if (event.propertyName === 'visibility') {
          document.querySelector('#shopify-section-header').style.zIndex = '';
          _this18.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
        }
      };
  
      this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
      this.pageOverlayElement.classList.remove('is-visible');
    }
  
    /**
     * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
     * then we disable submission using enter key
     */
  
    _preventSubmission(event) {
      if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
        event.preventDefault();
      }
    }
  
    /**
     * This is called when the user has stopped typing (after debounce delay)
     */
  
    _onInput(event) {
      var _this19 = this;
  
      if (event.keyCode === 13) {
        return;
      }
  
      // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
      // keep track of sent requests, and only use the results of the last one
      this.lastInputValue = event.target.value;
  
      if (this.lastInputValue === '') {
        this._resetSearch();
        return;
      }
  
      var queryOptions = { method: 'GET', credentials: 'same-origin' };
  
      var queries = [fetch('/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];
  
      if (window.theme.searchMode !== 'product') {
        queries.push(fetch('/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=' + window.theme.searchMode.replace('product,', ''), queryOptions));
      }
  
      this.queryMap[this.lastInputValue] = true;
  
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      Promise.all(queries).then(function (responses) {
        // If we receive the result for a query that is not the last one, we simply do not process the result
        if (_this19.lastInputValue !== event.target.value) {
          return;
        }
  
        delete _this19.queryMap[event.target.value];
  
        Promise.all(responses.map(function (response) {
          return response.text();
        })).then(function (contents) {
          // If we have only one content then we only have product, otherwise we have products and articles
          if (window.theme.searchMode === 'product') {
            _this19.searchResultsElement.innerHTML = contents[0];
          } else {
            _this19.searchResultsElement.innerHTML = '<div class="pageLayout pageLayout--breakLap">\n              <div class="pageLayout__section">' + contents[0] + '</div>\n              <div class="pageLayout__section pageLayout__section--secondary">' + contents[1] + '</div>\n            </div>';
          }
  
          _this19.searchResultsElement.setAttribute('aria-hidden', 'false');
        });
  
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
    }
    _resetSearch() {
      if (window.theme.searchMode === 'product') {
        this.searchResultsElement.innerHTML = '';
      } else {
        this.searchResultsElement.innerHTML = '<div class="pageLayout pageLayout--breakLap">\n              <div class="pageLayout__section"></div>\n              <div class="pageLayout__section pageLayout__section--secondary"></div>\n            </div>';
      }
  
      this.searchResultsElement.setAttribute('aria-hidden', 'true');
  
      document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
    }
  
    /**
     * Simple function that allows to debounce
     */
  
    _debounce(fn, delay) {
      var _this20 = this;
  
      var timer = null;
  
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
  
        clearTimeout(timer);
  
        timer = setTimeout(function () {
          fn.apply(_this20, args);
        }, delay);
      };
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/shipping-estimator.js":
  /*!******************************************************!*\
    !*** ./src/scripts/components/shipping-estimator.js ***!
    \******************************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ShippingEstimator; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _country_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./country-selector */ "./src/scripts/components/country-selector.js");
  /* harmony import */ var _tools_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tools/currency */ "./src/scripts/tools/currency.js");
  /* harmony import */ var _tools_animation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tools/animation */ "./src/scripts/tools/animation.js");
  
  
  
  
  
  
  class ShippingEstimator {
    constructor(element) {
  
      this.element = element;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
      this.countrySelector = new _country_selector__WEBPACK_IMPORTED_MODULE_1__["default"](this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));
      this._attachListeners();
    }
  
    onUnload() {
      this.delegateElement.off('click');
      this.countrySelector.destroy();
    }
    _attachListeners() {
      this.delegateElement.on('click', '.shippingEstimator__submit', this._fetchRates.bind(this));
    }
    _fetchRates() {
      var _this13 = this;
  
      var country = this.element.querySelector('[name="country"]').value,
          province = this.element.querySelector('[name="province"]').value,
          zip = this.element.querySelector('[name="zip"]').value;
  
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      fetch('/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.json().then(function (result) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
  
          var resultsContainer = _this13.element.querySelector('.shippingEstimator__results'),
              errorContainer = _this13.element.querySelector('.shippingEstimator__error');
  
          if (response.ok) {
            var shippingRates = result['shipping_rates'];
  
            if (shippingRates.length === 0) {
              resultsContainer.innerHTML = '<p>' + window.languages.shippingEstimatorNoResults + '</p>';
            } else {
              var html = '';
  
              if (shippingRates.length === 1) {
                html += '<p>' + window.languages.shippingEstimatorOneResult + '</p><ul>';
              } else {
                html += '<p>' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul>';
              }
  
              shippingRates.forEach(function (item) {
                html += '<li>' + item['name'] + ': ' + _tools_currency__WEBPACK_IMPORTED_MODULE_2__["default"].formatMoney(item['price'], window.theme.moneyFormat) + '</li>';
              });
  
              html += '</ul>';
  
              resultsContainer.firstElementChild.innerHTML = html;
            }
  
            TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, { autoAlpha: 0, y: -15 }, { autoAlpha: 1, y: 0, delay: 0.35 });
  
            errorContainer.style.display = 'none';
            resultsContainer.style.display = 'block';
  
            _tools_animation__WEBPACK_IMPORTED_MODULE_3__["default"].slideDown(resultsContainer);
          } else {
            var errorHtml = '';
  
            Object.keys(result).forEach(function (key) {
              errorHtml += '<li class="alert__errorItem">' + key + ' ' + result[key] + '</li>';
            });
  
            errorContainer.innerHTML = '<ul class="alert__errorList">' + errorHtml + '</ul>';
  
            resultsContainer.style.display = 'none';
            errorContainer.style.display = 'block';
          }
        });
      });
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/sidebar-menu.js":
  /*!************************************************!*\
    !*** ./src/scripts/components/sidebar-menu.js ***!
    \************************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SidebarMenuSection; });
  /* harmony import */ var _drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./drawer */ "./src/scripts/components/drawer.js");
  
  
  class SidebarMenuSection {
    constructor(container) {
      this.element = container;
      this.sidebarDrawer = new _drawer__WEBPACK_IMPORTED_MODULE_0__["default"](container);
    }
  
    onUnload() {
      this.sidebarDrawer.destroy();
    }
    onSelect() {
      this.sidebarDrawer.open();
    }
    onDeselect() {
      this.sidebarDrawer.close();
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/components/smooth-scroll.js":
  /*!*************************************************!*\
    !*** ./src/scripts/components/smooth-scroll.js ***!
    \*************************************************/
  /*! no exports provided */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  
  let documentDelegate = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(document.body),
      headerBar = document.querySelector('#shopify-section-header')
  
  documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
      let selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href')
  
      selector = /#(?:.(?!\\))+$/.exec(selector)[0]
  
      if (selector === '#') {
          return
      }
  
      let element = document.querySelector(selector),
          offset = parseInt(target.getAttribute('data-offset') || 0)

      if (headerBar) {
          offset -= headerBar.clientHeight
      }
  
      window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - (offset)
      })
  
      event.preventDefault()
  })
  
  /***/ }),
  
  /***/ "./src/scripts/layout/theme.js":
  /*!*************************************!*\
    !*** ./src/scripts/layout/theme.js ***!
    \*************************************/
  /*! no exports provided */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var lazysizes_plugins_object_fit_ls_object_fit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lazysizes/plugins/object-fit/ls.object-fit */ "./node_modules/lazysizes/plugins/object-fit/ls.object-fit.js");
  /* harmony import */ var lazysizes_plugins_object_fit_ls_object_fit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lazysizes_plugins_object_fit_ls_object_fit__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var lazysizes_plugins_parent_fit_ls_parent_fit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lazysizes/plugins/parent-fit/ls.parent-fit */ "./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js");
  /* harmony import */ var lazysizes_plugins_parent_fit_ls_parent_fit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lazysizes_plugins_parent_fit_ls_parent_fit__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */ var lazysizes_plugins_rias_ls_rias__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lazysizes/plugins/rias/ls.rias */ "./node_modules/lazysizes/plugins/rias/ls.rias.js");
  /* harmony import */ var lazysizes_plugins_rias_ls_rias__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lazysizes_plugins_rias_ls_rias__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */ var lazysizes_plugins_bgset_ls_bgset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lazysizes/plugins/bgset/ls.bgset */ "./node_modules/lazysizes/plugins/bgset/ls.bgset.js");
  /* harmony import */ var lazysizes_plugins_bgset_ls_bgset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lazysizes_plugins_bgset_ls_bgset__WEBPACK_IMPORTED_MODULE_3__);
  /* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js");
  /* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lazysizes__WEBPACK_IMPORTED_MODULE_4__);
  /* harmony import */ var lazysizes_plugins_respimg_ls_respimg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lazysizes/plugins/respimg/ls.respimg */ "./node_modules/lazysizes/plugins/respimg/ls.respimg.js");
  /* harmony import */ var lazysizes_plugins_respimg_ls_respimg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lazysizes_plugins_respimg_ls_respimg__WEBPACK_IMPORTED_MODULE_5__);
  /* harmony import */ var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! smoothscroll-polyfill */ "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js");
  /* harmony import */ var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_6__);
  /* harmony import */ var flickity_css_flickity_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! flickity/css/flickity.css */ "./node_modules/flickity/css/flickity.css");
  /* harmony import */ var flickity_css_flickity_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(flickity_css_flickity_css__WEBPACK_IMPORTED_MODULE_7__);
  /* harmony import */ var _sections_section_container__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../sections/section-container */ "./src/scripts/sections/section-container.js");
  /* harmony import */ var _components_collapsible__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../components/collapsible */ "./src/scripts/components/collapsible.js");
  /* harmony import */ var _components_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../components/modal */ "./src/scripts/components/modal.js");
  /* harmony import */ var _tools_responsive__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../tools/responsive */ "./src/scripts/tools/responsive.js");
  /* harmony import */ var _tools_loading_bar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../tools/loading-bar */ "./src/scripts/tools/loading-bar.js");
  /* harmony import */ var _components_popover__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../components/popover */ "./src/scripts/components/popover.js");
  /* harmony import */ var _components_cart_section__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../components/cart-section */ "./src/scripts/components/cart-section.js");
  /* harmony import */ var _sections_header__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../sections/header */ "./src/scripts/sections/header.js");
  /* harmony import */ var _components_sidebar_menu__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../components/sidebar-menu */ "./src/scripts/components/sidebar-menu.js");
  /* harmony import */ var _sections_newsletter_popup_section__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../sections/newsletter-popup-section */ "./src/scripts/sections/newsletter-popup-section.js");
  /* harmony import */ var _components_smooth_scroll__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../components/smooth-scroll */ "./src/scripts/components/smooth-scroll.js");
  /* harmony import */ var _components_carousel__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../components/carousel */ "./src/scripts/components/carousel.js");
  /* harmony import */ var _components_popup__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../components/popup */ "./src/scripts/components/popup.js");
  /* harmony import */ var _components_animations__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../components/animations */ "./src/scripts/components/animations.js");
  /* harmony import */ var _components_iframe__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../components/iframe */ "./src/scripts/components/iframe.js");
  /* harmony import */ var _components_iframe__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_components_iframe__WEBPACK_IMPORTED_MODULE_22__);
  /* harmony import */ var _components_mediabox__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../components/mediabox */ "./src/scripts/components/mediabox.js");
  /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
  /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_24__);
  /* harmony import */ var _components_cart__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../components/cart */ "./src/scripts/components/cart.js");
  /* harmony import */ var _styles_theme_scss__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../styles/theme.scss */ "./src/styles/theme.scss");
  /* harmony import */ var _styles_theme_scss__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_styles_theme_scss__WEBPACK_IMPORTED_MODULE_26__);
  /* harmony import */ var _styles_static_tailwind_scss__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../styles/static/tailwind.scss */ "./src/styles/static/tailwind.scss");
  /* harmony import */ var _styles_static_tailwind_scss__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_styles_static_tailwind_scss__WEBPACK_IMPORTED_MODULE_27__);
  
  
  
  
  
  
  
  
  // kick off the polyfill!
  smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_6___default.a.polyfill()
  
  var Flickity = __webpack_require__(/*! flickity */ "./node_modules/flickity/js/index.js");
  global.Flickity = Flickity
  __webpack_require__(/*! flickity-imagesloaded */ "./node_modules/flickity-imagesloaded/flickity-imagesloaded.js");
  __webpack_require__(/*! flickity-as-nav-for */ "./node_modules/flickity-as-nav-for/as-nav-for.js");
  __webpack_require__(/*! flickity-fade */ "./node_modules/flickity-fade/flickity-fade.js");
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  // import QuizSection from '../sections/quiz-section'
  
  
  
  
  
  
  
  
  
  
  
  
  
  global.$ = global.jQuery = jquery__WEBPACK_IMPORTED_MODULE_24___default.a 
  
  global._defineProperty = (obj, key, value) => { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  
  
  
  // import '../tools/breakpoints'
  
  
  
  
  
  // Apply a specific class to the html element for browser support of cookies.
  if (window.navigator.cookieEnabled) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies',
    )
  }
  
  
  // First, we register all plugins thate are used for all pages
  new _components_collapsible__WEBPACK_IMPORTED_MODULE_9__["default"]();
  new _components_modal__WEBPACK_IMPORTED_MODULE_10__["default"]();
  new _tools_responsive__WEBPACK_IMPORTED_MODULE_11__["default"]();
  // if (window.theme.template !== 'password' && window.theme.template !== 'gift_card') {
  //   new LoadingBar();
  // }
  
  document.querySelectorAll('.popover').forEach(function (popover) {
    if (popover.classList.contains('optionSelector')) {
      return false
    }
    new _components_popover__WEBPACK_IMPORTED_MODULE_13__["default"](popover, {
      showOverlay: true
    })
  })
    // register all plugins that are used for all pages
  if (window.theme.template !== 'password' && window.theme.template !== 'gift_card') {
    new _tools_loading_bar__WEBPACK_IMPORTED_MODULE_12__["default"]();
  }
  
  // instantiate specific sections that may appear in all pages
  global.sections = new _sections_section_container__WEBPACK_IMPORTED_MODULE_8__["default"]()
  
  sections.register('header', _sections_header__WEBPACK_IMPORTED_MODULE_15__["default"])
  sections.register('sidebar-menu', _components_sidebar_menu__WEBPACK_IMPORTED_MODULE_16__["default"]);
  sections.register('cart', _components_cart_section__WEBPACK_IMPORTED_MODULE_14__["default"])
  sections.register('newsletter-popup', _sections_newsletter_popup_section__WEBPACK_IMPORTED_MODULE_17__["default"]);
  // sections.register('quiz', QuizSection);
  
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))
  
  /***/ }),
  
  /***/ "./src/scripts/sections/header.js":
  /*!****************************************!*\
    !*** ./src/scripts/sections/header.js ***!
    \****************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderSection; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var fastdom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! fastdom */ "./node_modules/fastdom/fastdom.js");
  /* harmony import */ var fastdom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fastdom__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */ var stickyfilljs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! stickyfilljs */ "./node_modules/stickyfilljs/dist/stickyfill.js");
  /* harmony import */ var stickyfilljs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(stickyfilljs__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */ var _components_search_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/search-bar */ "./src/scripts/components/search-bar.js");
  /* harmony import */ var _tools_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../tools/dom */ "./src/scripts/tools/dom.js");
  /* harmony import */ var _tools_responsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../tools/responsive */ "./src/scripts/tools/responsive.js");
  
  
  
  
  
  
  
  
  class HeaderSection {
    constructor(container) {
      var _this43 = this;
  
      this.element = container;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.lastScrollPosition = -1;
      this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;
  
      if (this.options['isSticky']) {
        stickyfilljs__WEBPACK_IMPORTED_MODULE_2___default.a.addOne(this.element.parentNode);
      }
  
      // Scrolled
      window.addEventListener('scroll', function() {
          let scroll = window.scrollY;
          if (scroll > 0) {
            this.window.document.querySelector('.header').classList.add('header--scrolled')
          } else {
            this.window.document.querySelector('.header').classList.remove('header--scrolled')
          }
      }); 
  
      // Set up the search bar
      this.searchBar = new _components_search_bar__WEBPACK_IMPORTED_MODULE_3__["default"]();
  
      this._attachListeners();
      this._verifyNavigationOverlap();
  
      // We set again some CSS variables that are used for some calculations in CSS
      var mainLogo = this.element.querySelector('.header__logoImage--primary');
  
      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener('load', function () {
          fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this43.element.clientHeight + 'px');
            document.documentElement.style.setProperty('--header-is-not-transparent', _this43.options['hasTransparentHeader'] ? 0 : 1);
          });
        });
      } else {
        fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this43.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this43.options['hasTransparentHeader'] ? 0 : 1);
        });
      }
    }
  
    onUnload() {
      this.element.removeEventListener('mouseleave', this._closeNavigationListener);
      this.element.removeEventListener('mouseenter', this._focusNavigationListener);
      this.element.removeEventListener('focusin', this._focusNavigationListener);
  
      this.delegateElement.off();
  
      window.removeEventListener('scroll', this._checkTransparentHeaderListener);
      window.removeEventListener('resize', this._verifyNavigationOverlapListener);
  
      if (this.options['isSticky']) {
        stickyfilljs__WEBPACK_IMPORTED_MODULE_2___default.a.removeOne(this.element.parentNode);
      }
  
      this.searchBar.destroy();
    }
    onSelect() {
      this._checkTransparentHeader();
    }
    onBlockSelect(event) {
      var _this44 = this;
  
      var listItem = event.target.closest('.horizontalList__item');
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        event.target.setAttribute('aria-hidden', 'false');
  
        if (listItem) {
          listItem.classList.add('is-expanded');
  
          _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].getSiblings(listItem, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
          });
        }
  
        _this44.element.classList.remove('header--transparent'); // This is needed to make sure everything is visible
      });
    }
    onBlockDeselect(event) {
      var listItem = event.target.closest('.horizontalList__item');
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        event.target.setAttribute('aria-hidden', 'true');
  
        if (listItem) {
          listItem.classList.remove('is-expanded');
        }
      });
  
      this._checkTransparentHeader();
    }
    _attachListeners() {
      this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
      this._closeNavigationListener = this._closeNavigation.bind(this);
      this._focusNavigationListener = this._focusNavigation.bind(this);
      this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
  
      this.element.addEventListener('mouseleave', this._closeNavigationListener);
  
      this.delegateElement.on('mouseenter', '.header__mainNav .horizontalList__item, [aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
      this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
      this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);
  
      if (this.isTouch) {
        this.delegateElement.on('click', '.header__mainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
      }
  
      if (this.options['hasTransparentHeader']) {
        this.element.addEventListener('mouseenter', this._focusNavigationListener);
        this.element.addEventListener('focusin', this._focusNavigationListener);
      }
  
      if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
        window.addEventListener('scroll', this._checkTransparentHeaderListener);
      }
  
      if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
        window.addEventListener('resize', this._verifyNavigationOverlapListener);
      }
    }
    _focusNavigation() {
      var _this45 = this;
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        if (!_this45.isTouch || _tools_responsive__WEBPACK_IMPORTED_MODULE_5__["default"].matchesBreakpoint('desk')) {
          _this45.element.classList.remove('header--transparent');
        }
      });
    }
    _closeNavigation() {
      var _this46 = this;
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].nodeListToArray(_this46.element.querySelectorAll('.is-expanded')).forEach(function (item) {
          item.classList.remove('is-expanded');
        });
  
        _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].nodeListToArray(_this46.element.querySelectorAll('.header__mainNav [aria-hidden="false"]')).forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });
  
      if (this.options['hasTransparentHeader']) {
        this._checkTransparentHeader();
      }
    }
    _openMenu(event, target) {
      if (event.type === 'mouseenter' && target !== event.target) {
        return;
      }
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        target.classList.add('is-expanded');
        _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].nodeListToArray(target.children, '.header__mainNav [aria-hidden="true"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'false');
        });
  
        _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].getSiblings(target, '.is-expanded').forEach(function (item) {
          item.classList.remove('is-expanded');
  
          _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].nodeListToArray(item.children, '.header__mainNav [aria-hidden="false"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });
        });
      });
    }
    _closeMenu(event, target) {
      if (event.type === 'mouseleave' && target !== event.target) {
        return;
      }
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        target.classList.remove('is-expanded');
  
        _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].nodeListToArray(target.children, '.header__mainNav [aria-hidden="false"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });
    }
    _adjustDropdownPosition(event, target) {
      var nestedMenus = _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].nodeListToArray(target.querySelectorAll('.dropdownMenu')),
          shouldOpenLeft = false;
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.measure(function () {
        var windowWidth = window.innerWidth,
            rightEdge = target.getBoundingClientRect().right;
  
        nestedMenus.forEach(function (item) {
          if (rightEdge + item.offsetWidth > windowWidth) {
            shouldOpenLeft = true;
          }
        });
      });
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        if (shouldOpenLeft) {
          nestedMenus.forEach(function (item) {
            item.classList.add('dropdownMenu--reversed');
          });
        } else {
          nestedMenus.forEach(function (item) {
            item.classList.remove('dropdownMenu--reversed');
          });
        }
      });
    }
  
    /**
     * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
     * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
     * the sub-menu. If this link is clicked a second twice, then the menu is followed
     */
  
    _handleTouchMenu(event, target) {
      if (!target.classList.contains('is-expanded')) {
        event.preventDefault();
      }
    }
    _verifyNavigationOverlap() {
      var _this47 = this;
  
      var isOverlapping = false;
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.measure(function () {
        // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
        var mainTopMenu = _this47.element.querySelector('.header__mainNav');
  
        if (mainTopMenu) {
          // Get the first element
          var firstNavElementHeight = _tools_dom__WEBPACK_IMPORTED_MODULE_4__["default"].outerHeightWithMargin(mainTopMenu.querySelector('.horizontalList__item')),
              mainNavHeight = mainTopMenu.scrollHeight;
  
          if (mainNavHeight > firstNavElementHeight) {
            isOverlapping = true;
          }
        }
      });
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        if (isOverlapping) {
          _this47.element.classList.remove('header--' + _this47.options['navigationStyle']);
          _this47.element.classList.add('header--center');
        } else {
          _this47.element.classList.add('header--' + _this47.options['navigationStyle']);
          _this47.element.classList.remove('header--center');
        }
  
        _this47.element.classList.add('header--initialized');
  
        fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this47.element.clientHeight + 'px');
        });
      });
    }
  
    /**
     * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
     * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
     * scroll listener)
     */
  
    _checkTransparentHeader() {
      var _this48 = this;
  
      if (!this.options['hasTransparentHeader']) {
        return;
      }
  
      var scrollThreshold = 10;
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.measure(function () {
        _this48.lastScrollPosition = window.pageYOffset;
      });
  
      fastdom__WEBPACK_IMPORTED_MODULE_1___default.a.mutate(function () {
        if (_this48.lastScrollPosition <= scrollThreshold) {
          _this48.element.classList.add('header--transparent');
        } else {
          _this48.element.classList.remove('header--transparent');
        }
      });
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/sections/newsletter-popup-section.js":
  /*!**********************************************************!*\
    !*** ./src/scripts/sections/newsletter-popup-section.js ***!
    \**********************************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsletterPopupSection; });
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ftdomdelegate */ "./node_modules/ftdomdelegate/browser.js");
  /* harmony import */ var ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ftdomdelegate__WEBPACK_IMPORTED_MODULE_0__);
  
  
  class NewsletterPopupSection {
    constructor(element) {
      this.element = element;
      this.delegateElement = new ftdomdelegate__WEBPACK_IMPORTED_MODULE_0___default.a(this.element);
      this.options = JSON.parse(element.getAttribute('data-section-settings'));
  
      // If the popup has been already displayed, we do not display it
      try {
        if (window.location.hash === '#newsletter-popup' && window.theme.template !== null) {
          this._openPopup();
        } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
          setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
        }
      } catch (error) {
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }
  
      this._attachListeners();
    }
  
    onUnload() {
      this.delegateElement.off();
    }
    onSelect() {
      this._openPopup();
    }
    onDeselect() {
      this._closePopup();
    }
    _attachListeners() {
      this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
    }
    _openPopup() {
      this.element.setAttribute('aria-hidden', 'false');
      localStorage.setItem('themePopup', 'true');
    }
    _closePopup() {
      this.element.setAttribute('aria-hidden', 'true');
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/sections/section-container.js":
  /*!***************************************************!*\
    !*** ./src/scripts/sections/section-container.js ***!
    \***************************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SectionContainer; });
  /* harmony import */ var _tools_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../tools/dom */ "./src/scripts/tools/dom.js");
  /**
   * This code is extracted from Slate
   */
  
  
  
  class SectionContainer {
    constructor() {
      this.constructors = [];
      this.instances = [];
  
      this._attachListeners();
    }
  
    _attachListeners() {
      document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
      document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
      document.addEventListener('shopify:section:select', this._onSelect.bind(this));
      document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
      document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
      document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
    }
    register(type, constructor) {
      var _this58 = this;
  
      this.constructors[type] = constructor;
  
      _tools_dom__WEBPACK_IMPORTED_MODULE_0__["default"].nodeListToArray(document.querySelectorAll('[data-section-type=' + type + ']')).forEach(function (container) {
        _this58._createInstance(container, constructor);
      });
    }
  
    /**
     * Return an object from an array of objects that matches the provided key and value
     */
  
    _findInstance(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    }
  
    /**
     * Remove an object from an array of objects by matching the provided key and value
     */
  
    _removeInstance(array, key, value) {
      var i = array.length;
  
      while (i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
  
      return array;
    }
    _onSectionLoad(event) {
      var container = event.target.querySelector('[data-section-id]');
  
      if (container) {
        this._createInstance(container);
      }
    }
    _onSectionUnload(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
      if (!instance) {
        return;
      }
  
      if (typeof instance.onUnload === 'function') {
        instance.onUnload(event);
      }
  
      this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
    }
    _onSelect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(event);
      }
    }
    _onDeselect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(event);
      }
    }
    _onReorder(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
      if (instance && typeof instance.onReorder === 'function') {
        instance.onReorder(event);
      }
    }
    _onBlockSelect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(event);
      }
    }
    _onBlockDeselect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(event);
      }
    }
    _createInstance(container, constructor) {
      var id = container.getAttribute('data-section-id'),
          type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/tools/accessibility.js":
  /*!********************************************!*\
    !*** ./src/scripts/tools/accessibility.js ***!
    \********************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Accessibility; });
  class Accessibility {
    /**
     * Traps the focus in a particular container
     */
    static trapFocus(container, namespace) {
      this.listeners = this.listeners || {};
  
      // We check if there is an element with the attribute "autofocus"
      var elementToFocus = container.querySelector('[autofocus]') || container;
  
      container.setAttribute('tabindex', '-1');
      elementToFocus.focus();
  
      this.listeners[namespace] = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          container.focus();
        }
      };
  
      document.addEventListener('focusin', this.listeners[namespace]);
    }
  
    /**
     * Removes the trap of focus in a particular container
     */
  
    static removeTrapFocus(container, namespace) {
      if (container) {
        container.removeAttribute('tabindex');
      }
  
      document.removeEventListener('focusin', this.listeners[namespace]);
    }
  
    /**
     * Reset any previous trap focus
     */
  
    static clearTrapFocus() {
      for (var key in this.listeners) {
        if (this.listeners.hasOwnProperty(key)) {
          document.removeEventListener('focusin', this.listeners[key]);
        }
      }
  
      this.listeners = {};
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/tools/animation.js":
  /*!****************************************!*\
    !*** ./src/scripts/tools/animation.js ***!
    \****************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Animation; });
  class Animation {
    /**
     * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
     * force an animation
     */
    static slideUp(element) {
      element.style.height = element.scrollHeight + 'px'; // Force previous height to allow CSS transition
      element.offsetHeight; // Force redraw
      element.style.height = 0;
    }
  
    /**
     * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
     * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
     */
  
    static slideDown(element) {
      if (element.style.height === 'auto') {
        return;
      }
  
      // To do the animation we temporarily hide it, check the height, and transition to it
      element.style.height = element.firstElementChild.scrollHeight + 'px';
  
      var transitionEnded = function transitionEnded(event) {
        if (event.propertyName === 'height') {
          element.style.height = 'auto'; // Allows the content to grow normally
          element.removeEventListener('transitionend', transitionEnded);
        }
      };
  
      element.addEventListener('transitionend', transitionEnded);
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/tools/currency.js":
  /*!***************************************!*\
    !*** ./src/scripts/tools/currency.js ***!
    \***************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Currency; });
  /* harmony import */ var _dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom */ "./src/scripts/tools/dom.js");
  
  
  class Currency {
  
    /**
     * Format money values based on your shop currency settings
     *
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    static formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
  
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || '${{amount}}';
  
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.'),
            dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            centsAmount = parts[1] ? decimal + parts[1] : '';
  
        return dollarsAmount + centsAmount;
      }
  
      var value = '';
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      }
  
      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value).replace(',00', '');
      } else {
        return formatString.replace(placeholderRegex, value).replace('.00', '');
      }
    }
  
    /**
     * Allow to converts all elements from one currency to another. To speed up, you can pass a selector that will
     * act as the root element
     */
  
    static convertAll(selector) {
      var _this3 = this;
  
      var moneyFormats = {
        "USD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} USD"
        },
        "EUR": {
          "money_format": "&euro;{{amount}}",
          "money_with_currency_format": "&euro;{{amount}} EUR"
        },
        "GBP": {
          "money_format": "&pound;{{amount}}",
          "money_with_currency_format": "&pound;{{amount}} GBP"
        },
        "CAD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} CAD"
        },
        "ALL": {
          "money_format": "Lek {{amount}}",
          "money_with_currency_format": "Lek {{amount}} ALL"
        },
        "DZD": {
          "money_format": "DA {{amount}}",
          "money_with_currency_format": "DA {{amount}} DZD"
        },
        "AOA": {
          "money_format": "Kz{{amount}}",
          "money_with_currency_format": "Kz{{amount}} AOA"
        },
        "ARS": {
          "money_format": "${{amount_with_comma_separator}}",
          "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
        },
        "AMD": {
          "money_format": "{{amount}} AMD",
          "money_with_currency_format": "{{amount}} AMD"
        },
        "AWG": {
          "money_format": "Afl{{amount}}",
          "money_with_currency_format": "Afl{{amount}} AWG"
        },
        "AUD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} AUD"
        },
        "BBD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} Bds"
        },
        "AZN": {
          "money_format": "m.{{amount}}",
          "money_with_currency_format": "m.{{amount}} AZN"
        },
        "BDT": {
          "money_format": "Tk {{amount}}",
          "money_with_currency_format": "Tk {{amount}} BDT"
        },
        "BSD": {
          "money_format": "BS${{amount}}",
          "money_with_currency_format": "BS${{amount}} BSD"
        },
        "BHD": {
          "money_format": "{{amount}} BD",
          "money_with_currency_format": "{{amount}} BHD"
        },
        "BYR": {
          "money_format": "Br {{amount}}",
          "money_with_currency_format": "Br {{amount}} BYR"
        },
        "BZD": {
          "money_format": "BZ${{amount}}",
          "money_with_currency_format": "BZ${{amount}} BZD"
        },
        "BTN": {
          "money_format": "Nu {{amount}}",
          "money_with_currency_format": "Nu {{amount}} BTN"
        },
        "BAM": {
          "money_format": "KM {{amount_with_comma_separator}}",
          "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
        },
        "BRL": {
          "money_format": "R$ {{amount_with_comma_separator}}",
          "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
        },
        "BOB": {
          "money_format": "Bs{{amount_with_comma_separator}}",
          "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
        },
        "BWP": {
          "money_format": "P{{amount}}",
          "money_with_currency_format": "P{{amount}} BWP"
        },
        "BND": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} BND"
        },
        "BGN": {
          "money_format": "{{amount}} Ð»Ð²",
          "money_with_currency_format": "{{amount}} Ð»Ð² BGN"
        },
        "MMK": {
          "money_format": "K{{amount}}",
          "money_with_currency_format": "K{{amount}} MMK"
        },
        "KHR": {
          "money_format": "KHR{{amount}}",
          "money_with_currency_format": "KHR{{amount}}"
        },
        "KYD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} KYD"
        },
        "XAF": {
          "money_format": "FCFA{{amount}}",
          "money_with_currency_format": "FCFA{{amount}} XAF"
        },
        "CLP": {
          "money_format": "${{amount_no_decimals}}",
          "money_with_currency_format": "${{amount_no_decimals}} CLP"
        },
        "CNY": {
          "money_format": "&#165;{{amount}}",
          "money_with_currency_format": "&#165;{{amount}} CNY"
        },
        "COP": {
          "money_format": "${{amount_with_comma_separator}}",
          "money_with_currency_format": "${{amount_with_comma_separator}} COP"
        },
        "CRC": {
          "money_format": "&#8353; {{amount_with_comma_separator}}",
          "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
        },
        "HRK": {
          "money_format": "{{amount_with_comma_separator}} kn",
          "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
        },
        "CZK": {
          "money_format": "{{amount_with_comma_separator}} K&#269;",
          "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
        },
        "DKK": {
          "money_format": "{{amount_with_comma_separator}}",
          "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
        },
        "DOP": {
          "money_format": "RD$ {{amount}}",
          "money_with_currency_format": "RD$ {{amount}}"
        },
        "XCD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "EC${{amount}}"
        },
        "EGP": {
          "money_format": "LE {{amount}}",
          "money_with_currency_format": "LE {{amount}} EGP"
        },
        "ETB": {
          "money_format": "Br{{amount}}",
          "money_with_currency_format": "Br{{amount}} ETB"
        },
        "XPF": {
          "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
          "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
        },
        "FJD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "FJ${{amount}}"
        },
        "GMD": {
          "money_format": "D {{amount}}",
          "money_with_currency_format": "D {{amount}} GMD"
        },
        "GHS": {
          "money_format": "GH&#8373;{{amount}}",
          "money_with_currency_format": "GH&#8373;{{amount}}"
        },
        "GTQ": {
          "money_format": "Q{{amount}}",
          "money_with_currency_format": "{{amount}} GTQ"
        },
        "GYD": {
          "money_format": "G${{amount}}",
          "money_with_currency_format": "${{amount}} GYD"
        },
        "GEL": {
          "money_format": "{{amount}} GEL",
          "money_with_currency_format": "{{amount}} GEL"
        },
        "HNL": {
          "money_format": "L {{amount}}",
          "money_with_currency_format": "L {{amount}} HNL"
        },
        "HKD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "HK${{amount}}"
        },
        "HUF": {
          "money_format": "{{amount_no_decimals_with_comma_separator}}",
          "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
        },
        "ISK": {
          "money_format": "{{amount_no_decimals}} kr",
          "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
        },
        "INR": {
          "money_format": "Rs. {{amount}}",
          "money_with_currency_format": "Rs. {{amount}}"
        },
        "IDR": {
          "money_format": "{{amount_with_comma_separator}}",
          "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
        },
        "ILS": {
          "money_format": "{{amount}} NIS",
          "money_with_currency_format": "{{amount}} NIS"
        },
        "JMD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} JMD"
        },
        "JPY": {
          "money_format": "&#165;{{amount_no_decimals}}",
          "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
        },
        "JEP": {
          "money_format": "&pound;{{amount}}",
          "money_with_currency_format": "&pound;{{amount}} JEP"
        },
        "JOD": {
          "money_format": "{{amount}} JD",
          "money_with_currency_format": "{{amount}} JOD"
        },
        "KZT": {
          "money_format": "{{amount}} KZT",
          "money_with_currency_format": "{{amount}} KZT"
        },
        "KES": {
          "money_format": "KSh{{amount}}",
          "money_with_currency_format": "KSh{{amount}}"
        },
        "KWD": {
          "money_format": "{{amount}} KD",
          "money_with_currency_format": "{{amount}} KWD"
        },
        "KGS": {
          "money_format": "Ð»Ð²{{amount}}",
          "money_with_currency_format": "Ð»Ð²{{amount}}"
        },
        "LVL": {
          "money_format": "Ls {{amount}}",
          "money_with_currency_format": "Ls {{amount}} LVL"
        },
        "LBP": {
          "money_format": "L&pound;{{amount}}",
          "money_with_currency_format": "L&pound;{{amount}} LBP"
        },
        "LTL": {
          "money_format": "{{amount}} Lt",
          "money_with_currency_format": "{{amount}} Lt"
        },
        "MGA": {
          "money_format": "Ar {{amount}}",
          "money_with_currency_format": "Ar {{amount}} MGA"
        },
        "MKD": {
          "money_format": "Ð´ÐµÐ½ {{amount}}",
          "money_with_currency_format": "Ð´ÐµÐ½ {{amount}} MKD"
        },
        "MOP": {
          "money_format": "MOP${{amount}}",
          "money_with_currency_format": "MOP${{amount}}"
        },
        "MVR": {
          "money_format": "Rf{{amount}}",
          "money_with_currency_format": "Rf{{amount}} MRf"
        },
        "MXN": {
          "money_format": "$ {{amount}}",
          "money_with_currency_format": "$ {{amount}} MXN"
        },
        "MYR": {
          "money_format": "RM{{amount}} MYR",
          "money_with_currency_format": "RM{{amount}} MYR"
        },
        "MUR": {
          "money_format": "Rs {{amount}}",
          "money_with_currency_format": "Rs {{amount}} MUR"
        },
        "MDL": {
          "money_format": "{{amount}} MDL",
          "money_with_currency_format": "{{amount}} MDL"
        },
        "MAD": {
          "money_format": "{{amount}} dh",
          "money_with_currency_format": "Dh {{amount}} MAD"
        },
        "MNT": {
          "money_format": "{{amount_no_decimals}} &#8366",
          "money_with_currency_format": "{{amount_no_decimals}} MNT"
        },
        "MZN": {
          "money_format": "{{amount}} Mt",
          "money_with_currency_format": "Mt {{amount}} MZN"
        },
        "NAD": {
          "money_format": "N${{amount}}",
          "money_with_currency_format": "N${{amount}} NAD"
        },
        "NPR": {
          "money_format": "Rs{{amount}}",
          "money_with_currency_format": "Rs{{amount}} NPR"
        },
        "ANG": {
          "money_format": "&fnof;{{amount}}",
          "money_with_currency_format": "{{amount}} NA&fnof;"
        },
        "NZD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} NZD"
        },
        "NIO": {
          "money_format": "C${{amount}}",
          "money_with_currency_format": "C${{amount}} NIO"
        },
        "NGN": {
          "money_format": "&#8358;{{amount}}",
          "money_with_currency_format": "&#8358;{{amount}} NGN"
        },
        "NOK": {
          "money_format": "kr {{amount_with_comma_separator}}",
          "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
        },
        "OMR": {
          "money_format": "{{amount_with_comma_separator}} OMR",
          "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
        },
        "PKR": {
          "money_format": "Rs.{{amount}}",
          "money_with_currency_format": "Rs.{{amount}} PKR"
        },
        "PGK": {
          "money_format": "K {{amount}}",
          "money_with_currency_format": "K {{amount}} PGK"
        },
        "PYG": {
          "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
          "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
        },
        "PEN": {
          "money_format": "S/. {{amount}}",
          "money_with_currency_format": "S/. {{amount}} PEN"
        },
        "PHP": {
          "money_format": "&#8369;{{amount}}",
          "money_with_currency_format": "&#8369;{{amount}} PHP"
        },
        "PLN": {
          "money_format": "{{amount_with_comma_separator}} zl",
          "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
        },
        "QAR": {
          "money_format": "QAR {{amount_with_comma_separator}}",
          "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
        },
        "RON": {
          "money_format": "{{amount_with_comma_separator}} lei",
          "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
        },
        "RUB": {
          "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
          "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
        },
        "RWF": {
          "money_format": "{{amount_no_decimals}} RF",
          "money_with_currency_format": "{{amount_no_decimals}} RWF"
        },
        "WST": {
          "money_format": "WS$ {{amount}}",
          "money_with_currency_format": "WS$ {{amount}} WST"
        },
        "SAR": {
          "money_format": "{{amount}} SR",
          "money_with_currency_format": "{{amount}} SAR"
        },
        "STD": {
          "money_format": "Db {{amount}}",
          "money_with_currency_format": "Db {{amount}} STD"
        },
        "RSD": {
          "money_format": "{{amount}} RSD",
          "money_with_currency_format": "{{amount}} RSD"
        },
        "SCR": {
          "money_format": "Rs {{amount}}",
          "money_with_currency_format": "Rs {{amount}} SCR"
        },
        "SGD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} SGD"
        },
        "SYP": {
          "money_format": "S&pound;{{amount}}",
          "money_with_currency_format": "S&pound;{{amount}} SYP"
        },
        "ZAR": {
          "money_format": "R {{amount}}",
          "money_with_currency_format": "R {{amount}} ZAR"
        },
        "KRW": {
          "money_format": "&#8361;{{amount_no_decimals}}",
          "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
        },
        "LKR": {
          "money_format": "Rs {{amount}}",
          "money_with_currency_format": "Rs {{amount}} LKR"
        },
        "SEK": {
          "money_format": "{{amount_no_decimals}} kr",
          "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
        },
        "CHF": {
          "money_format": "{{amount}} CHF",
          "money_with_currency_format": "{{amount}} CHF"
        },
        "TWD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} TWD"
        },
        "THB": {
          "money_format": "{{amount}} &#xe3f;",
          "money_with_currency_format": "{{amount}} &#xe3f; THB"
        },
        "TZS": {
          "money_format": "{{amount}} TZS",
          "money_with_currency_format": "{{amount}} TZS"
        },
        "TTD": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}} TTD"
        },
        "TND": {
          "money_format": "{{amount}}",
          "money_with_currency_format": "{{amount}} DT"
        },
        "TRY": {
          "money_format": "{{amount}}TL",
          "money_with_currency_format": "{{amount}}TL"
        },
        "UGX": {
          "money_format": "Ush {{amount_no_decimals}}",
          "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
        },
        "UAH": {
          "money_format": "₴{{amount}}",
          "money_with_currency_format": "{{amount}} UAH"
        },
        "AED": {
          "money_format": "Dhs. {{amount}}",
          "money_with_currency_format": "Dhs. {{amount}} AED"
        },
        "UYU": {
          "money_format": "${{amount_with_comma_separator}}",
          "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
        },
        "VUV": {
          "money_format": "${{amount}}",
          "money_with_currency_format": "${{amount}}VT"
        },
        "VEF": {
          "money_format": "Bs. {{amount_with_comma_separator}}",
          "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
        },
        "VND": {
          "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
          "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
        },
        "XBT": {
          "money_format": "{{amount_no_decimals}} BTC",
          "money_with_currency_format": "{{amount_no_decimals}} BTC"
        },
        "XOF": {
          "money_format": "CFA{{amount}}",
          "money_with_currency_format": "CFA{{amount}} XOF"
        },
        "ZMW": {
          "money_format": "K{{amount_no_decimals_with_comma_separator}}",
          "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
        }
      };
  
      var baseCurrency = window.theme.shopCurrency,
          newCurrency = document.querySelector('.currencySelector__select').value;
  
      _dom__WEBPACK_IMPORTED_MODULE_0__["default"].nodeListToArray((selector || document).querySelectorAll('[data-money-convertible]')).forEach(function (item) {
        if (!item.hasAttribute('data-currency-' + baseCurrency)) {
          item.setAttribute('data-currency-' + baseCurrency, item.innerHTML);
        }
  
        // If the amount has already been converted, we leave it alone.
        if (item.getAttribute('data-currency') === newCurrency) {
          return;
        }
  
        var baseAmount = item.getAttribute('data-currency-' + baseCurrency);
  
        // If we are converting to a currency that we have saved, we will use the saved amount.
        if (item.hasAttribute('data-currency-' + newCurrency)) {
          item.innerHTML = item.getAttribute('data-currency-' + newCurrency);
        } else {
          var newFormat = moneyFormats[newCurrency][window.theme.currencyConversionMoneyFormat] || '{{amount}}';
  
          // We have to normalize by replacing dot by comma and comma by dot
          if (window.theme.moneyFormat.indexOf('with_comma_separator') !== -1) {
            baseAmount = baseAmount.replace(/[,.]/g, function (match) {
              // If `,` is matched return `.`, if `.` matched return `,`
              return match === ',' ? '.' : ',';
            });
          }
  
          // Converting to Y for the first time? Let's get to it!
          var cents = window.Currency.convert(parseFloat(baseAmount.replace(/^[^0-9]+|[^0-9.]/g, '', ''), 10) * 100, baseCurrency, newCurrency);
  
          if (window.theme.currencyConversionRoundAmounts) {
            cents = Math.round(cents / 100) * 100;
          }
  
          var newFormattedAmount = _this3.formatMoney(cents, newFormat);
  
          item.innerHTML = newFormattedAmount;
          item.setAttribute('data-currency-' + newCurrency, newFormattedAmount);
        }
  
        // We record the new currency locally.
        item.setAttribute('data-currency', newCurrency);
      });
  
      localStorage.setItem('currency', newCurrency);
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/tools/dom.js":
  /*!**********************************!*\
    !*** ./src/scripts/tools/dom.js ***!
    \**********************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Dom; });
  class Dom {
  
    /**
     * Get all the previous and next siblings, optionally filtered by a selector
     */
    static getSiblings(element, filter) {
      var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  
      var siblings = [];
      var currentElement = element;
  
      // Do the previous first
      while (currentElement = currentElement.previousElementSibling) {
        if (!filter || currentElement.matches(filter)) {
          siblings.push(currentElement);
        }
      }
  
      if (includeSelf) {
        siblings.push(element);
      }
  
      // Then the next side
      currentElement = element;
  
      while (currentElement = currentElement.nextElementSibling) {
        if (!filter || currentElement.matches(filter)) {
          siblings.push(currentElement);
        }
      }
  
      return siblings;
    }
  
    /**
     * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
     * we need to normalize it
     */
  
    static nodeListToArray(nodeList, filter) {
      var items = [];
  
      for (var i = 0; i !== nodeList.length; ++i) {
        if (!filter || nodeList[i].matches(filter)) {
          items.push(nodeList[i]);
        }
      }
  
      return items;
    }
  
    /**
     * Calculate an element width with its margin
     */
  
    static outerWidthWithMargin(element) {
      var width = element.offsetWidth,
          style = getComputedStyle(element);
  
      width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  
      return width;
    }
  
    /**
     * Calculate an element height with its margin
     */
  
    static outerHeightWithMargin(element) {
      var height = element.offsetHeight,
          style = getComputedStyle(element);
  
      height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  
      return height;
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/tools/loading-bar.js":
  /*!******************************************!*\
    !*** ./src/scripts/tools/loading-bar.js ***!
    \******************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LoadingBar; });
  /**
   * Simple plugin that handles the loading bar actions
   *
   * This plugin uses delegate events so it's independent of the sections.
   */
  
  class LoadingBar {
    constructor () {
      this.element = document.querySelector('.loadingBar');
  
      document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
      document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
  
      this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
    }
  
    _onLoadingStart() {
      this.element.classList.add('is-visible');
      this.element.style.width = '40%';
    }
    _onLoadingEnd() {
      this.element.style.width = '100%';
      this.element.classList.add('is-finished');
    }
    _onTransitionEnd(event) {
      if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
        this.element.classList.remove('is-visible');
        this.element.classList.remove('is-finished');
        this.element.style.width = '0';
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/scripts/tools/responsive.js":
  /*!*****************************************!*\
    !*** ./src/scripts/tools/responsive.js ***!
    \*****************************************/
  /*! exports provided: default */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Responsive; });
  class Responsive {
    constructor () {
      var _this2 = this;
  
      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
  
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();
  
        if (_this2.currentBreakpoint === newBreakpoint) {
          return;
        }
  
        document.dispatchEvent(new CustomEvent('breakpoint:changed', { detail: {
            previousBreakpoint: _this2.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          } }));
  
        _this2.currentBreakpoint = newBreakpoint;
      });
    }
  
    static matchesBreakpoint(breakpoint) {
      switch (breakpoint) {
        case 'phone':
          return window.matchMedia('screen and (max-width: 640px)').matches;
  
        case 'sm':
          return window.matchMedia('screen and (min-width: 641px)').matches;
  
        case 'pocket':
          return window.matchMedia('screen and (max-width: 767px)').matches;
  
        case 'md':
          return window.matchMedia('screen and (min-width: 768px)').matches;
  
        case 'lg':
          return window.matchMedia('screen and (min-width: 1024px)').matches;
  
        case 'xl':
          return window.matchMedia('screen and (min-width: 1256px)').matches;
  
        case '2xl':
          return window.matchMedia('screen and (min-width: 1600px)').matches;
      }
    }
    static getCurrentBreakpoint() {
      if (window.matchMedia('screen and (max-width: 640px)').matches) {
        return 'phone';
      }
  
      if (window.matchMedia('screen and (min-width: 641px)').matches) {
        return 'sm';
      }
  
      if (window.matchMedia('screen and (min-width: 768px)').matches) {
        return 'md';
      }
  
      if (window.matchMedia('screen and (min-width: 1024px)').matches) {
        return 'lg';
      }
  
      if (window.matchMedia('screen and (min-width: 1256px)').matches) {
        return 'xl';
      }
  
      if (window.matchMedia('screen and (min-width: 1600px)').matches) {
        return '2xl';
      }
    }
  }
  
  /***/ }),
  
  /***/ "./src/styles/static/tailwind.scss":
  /*!*****************************************!*\
    !*** ./src/styles/static/tailwind.scss ***!
    \*****************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  // extracted by extract-css-chunks-webpack-plugin
  
  /***/ }),
  
  /***/ "./src/styles/theme.scss":
  /*!*******************************!*\
    !*** ./src/styles/theme.scss ***!
    \*******************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  // extracted by extract-css-chunks-webpack-plugin
  
  /***/ })
  
  /******/ }); 